$(document).ready(function () {
  // HOME
  // Redirection lien section medias
  $(document).on("click", ".section-images .column", function () {
    var redirect = $(this).find("a:first-child").attr("href");
    if (redirect) {
      window.location.href = redirect;
    }
  });
  // Redirection lien section multicolonne
  $(document).on("click", ".multicolumn .multicolumn-list__item", function () {
    var redirect = $(this).data("target");
    if (redirect) {
      window.location.href = redirect;
    }
  });

  // Menu mobile
  // ----------------------------------------------------------------------------
  // Switch onglets section détails produit
  $(document).on("click", ".custom_mobile_navigation nav a", function (event) {
    var $level = $(this).data("level");
    $(".custom_mobile_navigation nav a").removeClass("active");
    $(this).addClass("active");
    $(".nav_levels > div").hide();
    $(".nav_levels > div[data-target=" + $level + "]").show();
  });

  // Footer
  // --------------------------------------------
  // Accordeon footer mobile
  if ($(window).width() <= 989) {
    $(document).on("click", ".footer_level_1 > li", function () {
      var title = $(".footer_level_1 > li");
      var content = $(".footer_level_2");
      $(this).find(".link_level_1").toggleClass("opened");
      if (content.length) {
        $(title).not($(this)).find(".link_level_1").removeClass("opened");
        $(title).not($(this)).find(content).slideUp();
        $(this).find(content).slideToggle();
      }
    });
  }

  // Cart drawer
  // ----------------------------------------------------------------------------
  // Switch onglets section détails produit
  $(document).on("click", ".drawer__upsell .icon-close", function (event) {
    console.log("click");
    $(".drawer__upsell").slideUp();
  });

  // Home
  // ----------------------------------------------------------------------------
  if ($(".section-carrousel-media").length) {
    $(".section-carrousel-media").slick({
      slidesToScroll: 1,
      slidesToShow: 4,
      arrows: false,
      dots: true,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            arrows: false,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
          },
        },
      ],
    });
  }

  // Page collection
  // ----------------------------------------------------------------------------

  // Load more
  $(document).on("click", ".js-load-more", function () {
    var $this = $(this),
      totalPages = parseInt($("[data-total-pages]").val()),
      currentPage = parseInt($("[data-current-page]").val());
    $this.attr("disabled", true);
    $this.find("[load-more-text]").addClass("hide");
    $this.find("[loader]").removeClass("hide");
    currentPage = currentPage + 1;
    var nextUrl = $("[data-next-url]")
      .val()
      .replace(/page=[0-9]+/, "page=" + currentPage);
    $("[data-current-page]").val(currentPage);
    $.ajax({
      url: nextUrl,
      type: "GET",
      dataType: "html",
      success: function (responseHTML) {
        $(".collection-grid").append($(responseHTML).find(".collection-grid").html());
        $(".pagination_count").html($(responseHTML).find(".pagination_count").html());
      },
      complete: function () {
        if (currentPage <= totalPages) {
          $this.attr("disabled", false);
          $this.find("[load-more-text]").removeClass("hide");
          $this.find("[loader]").addClass("hide");
        }
        if (currentPage == totalPages) {
          $this.hide();
        }
      },
    });
  });

  // Card Collection redirection après clic sur image
  $(document).on("click", ".product-card-wrapper .card__inner", function (e) {
    // Ne pas rediriger si on clique sur un lien, un bouton, le quick-add
    // ou les contrôles du swiper (flèches / scrollbar).
    if (
      $(e.target).closest(
        "a, button, .quick-add, modal-opener, product-form, .swiper-button-next, .swiper-button-prev, .swiper-scrollbar"
      ).length
    ) {
      return;
    }
    var redirect = $(this).next(".card__content").find("a").attr("href");
    if (redirect) {
      window.location.href = redirect;
    }
  });

  // Redirection sur les liens des pushs au clic sur l'image
  $(document).on("click", ".push", function () {
    var redirect = $(this).data("target");
    if (redirect) {
      window.location.href = redirect;
    }
  });

  // Accordon contenus FAQ et SEO
  $(document).on("click", ".faq_accordeon h3", function () {
    var title = $(".faq_accordeon h3");
    var content = $(".faq_accordeon .answer");
    $(this).toggleClass("active");
    if (content.length) {
      $(title).not($(this)).removeClass("active");
      $(title).not($(this)).next(content).slideUp();
      $(this).next(content).slideToggle();
    }
  });

  $(document).on("click", ".section_accordeon .content .h3", function () {
    var title = $(".section_accordeon .content .h3");
    var content = $(".content > div");
    $(this).toggleClass("active");
    if (content.length) {
      $(title).not($(this)).removeClass("active");
      $(title).not($(this)).next("div").slideUp();
      $(this).next("div").slideToggle();
    }
  });

  // Accordéon des filtres : le drawer est utilisé sur toutes les tailles
  // d'écran (mobile + desktop), donc ce handler doit être branché partout.
  $(document).on("click", ".mobile-facets__summary", function () {
    var title = $(".mobile-facets__summary");
    var content = $(".mobile-facets__submenu");
    $(this).toggleClass("active");
    if (content.length) {
      $(title).not($(this)).removeClass("active");
      $(title).not($(this)).next("div").slideUp();
      $(this).next("div").slideToggle();
    }
  });

  if ($(window).width() > 989) {
    $(document).on("click", ".section_accordeon nav h3", function (event) {
      var $name = $(this).data("name");
      $(this).parents(".section_accordeon").find("nav h3").removeClass("active");
      $(this).addClass("active");
      $(this).parents(".section_accordeon").find(".content").removeClass("active");
      $(this)
        .parents(".section_accordeon")
        .find("div[data-target=" + $name + "]")
        .addClass("active");
    });
  }

  // Tri
  $(document).on("click", ".mobile-facets__label", function () {
    console.log("click");
    $(this).find(".icon-checkmark").toggleClass("active");
  });

  // Page produit
  // ----------------------------------------------------------------------------
  $(document).on("click", ".icon-close", function (event) {
    $("#overlay").fadeOut(300);
    $(".back_in_stock_popin").css("right", "-100%");
    $("body").removeClass("overflow-hidden");
    $(".response").hide();
  });

  $(document).on("click", ".add_product_span", function (event) {
    if ($(this).hasClass("trigger_bis")) {
      const variant_id = $('.product__info-wrapper .product-variant-id').val();
      $("body").addClass("overflow-hidden");
      $("#overlay").fadeIn(300);
      $(".back_in_stock_popin").css("right", "0");
      $('select[name="variant_bis"] option').attr('selected', false);
      $('select[name="variant_bis"] option[value="'+variant_id+'"').attr('selected', true);
    }
  });

  $(document).on("click", ".product-form__submit.disabled", function (event) {
    event.preventDefault();
  });

  // Formulaire Back In Stock
  $("#bis_form").submit(async function (event) {
    event.preventDefault();
    const url = "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=TFbkyM";
    const options = {
      method: "POST",
      headers: {
        accept: "application/json",
        revision: "2024-02-15",
        "content-type": "application/json",
      },
      body: JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: $("#email_bis").val(),
                },
              },
            },
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: "$custom:::$default:::" + $(this).find('select[name="variant_bis"]').val(),
              },
            },
          },
        },
      }),
    };

    let response = await fetch(url, options);

    if (response.ok) {
     $(".validation").show();
    } else {
     $(".error").show();
      let json = await response.json();
      console.log(json);
    }
  });

  // Popin STL
  //Ouverture popin
  $(document).on('click', '.see_look', function () {
    $(".look").addClass("active");
  });

  // Fermeture popin
  $(document).on('click', '.look .close', function () {
    $(".look").removeClass("active");
  });


  $(window).on('keyup', function () {
    $(".look").removeClass("active");
  });

  // Fermeture popin après ajout au panier
  $(document).on('click', '.look .quick-add__submit', function () {
    setTimeout(() => {
    $(".look").removeClass("active");
    }, 1000);
  });

  // Ouverture popin de contenu
  $(document).on("click", ".sizing", function (event) {
    var name = $(this).attr("class");
    $("body").addClass("overflow-hidden");
    $("#overlay").fadeIn(300);
    $("." + name + "_content").css("right", "0");
  });

  $(document).on("click", ".tabs > p", function (event) {
    var name = $(this).data("title");
    $("body").addClass("overflow-hidden");
    $("#overlay").fadeIn(300);
    $(".details_content").css("right", "0");
    $(".details_content p[data-title=" + name + "]").addClass("active");
    $(".accordeon_content > div[data-target=" + name + "]").css("display", "block");
  });

  $(document).on("click", ".details_content p[data-title]", function (event) {
    var name = $(this).data("title");
    // Onglet déjà ouvert : on le referme (aucun onglet ouvert est un état valide).
    var wasOpen = $(this).hasClass("active");
    $(".details_content p[data-title]").removeClass("active");
    $(".accordeon_content > div:not(.close)").hide();
    if (wasOpen) {
      return;
    }
    $(this).addClass("active");
    $(".accordeon_content > div[data-target=" + name + "]").show();
  });

    // Fermeture popin de contenu
  $(document).on("click", ".close", function (event) {
    $("#overlay").fadeOut(300);
    $(".popin").css("right", "-100%");
    $("body").removeClass("overflow-hidden");
    $(".details_content p[data-title]").removeClass("active");
    $(".accordeon_content > div:not(.close)").css("display", "none");
  });

  // Switch onglets section détails produit
  $(document).on("click", ".product_details_section nav span", function (event) {
    var $name = $(this).data("name");
    $(".product_details_section nav span").removeClass("selected");
    $(this).addClass("selected");
    $(".product_details_section > div").hide();
    $(".product_details_section > div[data-target=" + $name + "]").css("display", "flex");
  });

  // Switch cross (onglets PDP)
  // Uniquement en desktop : en mobile le nav est masqué et tous les blocs
  // sliders sont empilés (voir _product.scss / related-products.liquid).
  $(document).on("click", "nav.cross_nav span", function (event) {
    if ($(window).width() <= 749) return;
    var $name = $(this).data("name");
    $("nav.cross_nav span").removeClass("selected");
    $(this).addClass("selected");
    $(".cross_content > *").hide();
    $(".cross_content > #" + $name).css("display", "block");
  });

  //swiper mobile
  // La galerie PDP a deux modes en mobile, pilotés par l'option
  // « Activer le nouvel affichage des médias » (section Infos produit) :
  //  - Activé (.product--mobile-media-stacked présent) : les médias sont
  //    empilés verticalement (1er média en hero au-dessus du bloc info, les
  //    autres en dessous). Pas de carrousel. Voir section-main-product.css.
  //  - Désactivé : on retrouve le carrousel horizontal Swiper d'origine ;
  //    on l'initialise donc ici uniquement dans ce cas.
  if (
    $(".product_page_section .product_swiper").length &&
    $(window).width() < 990 &&
    !$(".product_page_section .product--mobile-media-stacked").length
  ) {
    new Swiper(".product_page_section .product_swiper", {
      loop: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
      },
    });
  }

  // Fix zoom lightbox : à la fermeture de la popin de zoom, ModalDialog.hide()
  // redonne le focus au bouton .product__media-toggle qui l'a ouverte (via
  // removeTrapFocus). Ce bouton (dont la surface cliquable est son ::after)
  // devient alors document.activeElement, à l'intérieur du slide. Or Swiper
  // court-circuite le touchmove lorsque la cible touchée est l'élément actif
  // ET focusable ("if (target === activeElement && target.matches(
  // focusableElements)) return"), ce qui fige le swipe sur ce média une fois
  // la popin refermée. On retire donc le focus du toggle à la fermeture : un
  // swipe (drag) ne le refocalise pas, alors qu'un vrai tap rouvre le zoom.
  // Le setTimeout est nécessaire car hide() émet "modalClosed" AVANT son
  // removeTrapFocus() : on doit débloquer le focus après ce dernier.
  document.body.addEventListener("modalClosed", function () {
    setTimeout(function () {
      var active = document.activeElement;
      if (active && active.classList.contains("product__media-toggle")) {
        active.blur();
      }
    }, 0);
  });

  // Sticky button sur fiche produit
  $(document).on("click", ".details_link", function (event) {
    var offset = $("#more_details").offset().top - 60;
    $("html, body").animate({ scrollTop: offset });
  });

  // Barre sticky (mobile) : sélection d'une taille sur le formulaire autonome.
  // Les tailles indisponibles restent cliquables : elles basculent le bouton
  // vers l'alerte retour en stock (et réaffichent le prix dans product-info).
  $(document).on("click", "#sticky_basket .sticky_basket__variant", function (event) {
    event.preventDefault();
    var $pill = $(this);

    $pill.addClass("is-selected").siblings().removeClass("is-selected");

    var variantId = $pill.data("card_product_variant_id");
    var available = String($pill.attr("data-variant-available")) === "true";

    // Synchronise l'input du formulaire sticky et l'input principal
    // (ce dernier est lu par le déclencheur BIS pour présélectionner la variante).
    $pill.closest("product-form").find("input.product-variant-id").prop("disabled", false).val(variantId);
    $(".product__info-wrapper .product-variant-id").val(variantId);

    if (available) {
      $("body").removeClass("sticky-oos-selected");
      var price = $pill.attr("data-variant-price");
      if (price) {
        $("#sticky_basket")
          .find(
            ".sticky_basket__submit-price .price__regular .price-item--regular, .sticky_basket__submit-price .price__sale .price-item--last"
          )
          .html(price);
      }
    } else {
      $("body").addClass("sticky-oos-selected");
    }

  });

  // Barre sticky (mobile) : déplacer le bouton Kleep « Trouver ma taille idéale »
  // (app block injecté après le chargement) dans le sticky sur mobile, et le
  // remettre à sa position d'origine dans product-info sur desktop. On déplace
  // le nœud réel (pas de clone) pour conserver les écouteurs du SDK Kleep.
  //
  // NB : le déplacement du bouton ne redimensionne PAS le visuel hero. Sa
  // hauteur (34px + marge) est déjà réservée dès le calcul initial de
  // --hero-h, exécuté en synchrone avant le 1er rendu (voir le <script> dans
  // main-product.liquid, juste après le visuel hero) — donc pas de
  // redimensionnement à corriger ici.
  (function () {
    var kleepAnchor = null;

    function getKleepBlock() {
      return document.querySelector('[id*="kleep_hartford_button"]');
    }

    function kleepReady() {
      // Le bouton est réellement injecté par le SDK Kleep (pas juste le conteneur).
      return !!document.getElementById("kleep-size-button");
    }

    function placeKleep() {
      var block = getKleepBlock();
      var mount = document.querySelector("#sticky_basket .sticky_basket__kleep");
      if (!block || !mount) {
        return;
      }
      // Mémorise la position d'origine une seule fois (le wrapper existe dès le chargement).
      if (!kleepAnchor) {
        kleepAnchor = document.createComment("kleep-anchor");
        block.parentNode.insertBefore(kleepAnchor, block);
      }
      // Barre sticky désactivée pour ce produit (réglage "Activer la barre
      // sticky d'ajout au panier", section Infos produit) : le bouton Kleep
      // reste à sa place d'origine dans product-info, comme sur desktop.
      var stickyDisabled = document.body.classList.contains("sticky-atc-disabled");
      if (window.innerWidth <= 749 && !stickyDisabled) {
        // IMPORTANT : on ne déplace le conteneur QU'UNE FOIS le bouton hydraté
        // par le SDK Kleep. Déplacer le conteneur vide trop tôt empêche le SDK
        // de le retrouver et d'injecter le bouton (bug observé sur iOS).
        if (kleepReady() && block.parentNode !== mount) {
          mount.appendChild(block);
        }
      } else if (block.parentNode === mount && kleepAnchor.parentNode) {
        kleepAnchor.parentNode.insertBefore(block, kleepAnchor.nextSibling);
      }
    }

    var kleepMount = document.querySelector("#sticky_basket .sticky_basket__kleep");
    if (kleepMount) {
      // Le conteneur .sticky_basket__kleep est masqué tant qu'il est vide (CSS
      // :empty) — y compris sur les produits sans reco (taille unique, etc.) où
      // le bouton n'existe jamais. On se contente de déplacer le bouton dès
      // qu'il est hydraté par le SDK Kleep (le hero, lui, a déjà réservé la
      // place au chargement, voir plus haut).
      placeKleep();
      if (!kleepReady() && typeof MutationObserver !== "undefined") {
        var kleepObserver = new MutationObserver(function () {
          if (kleepReady()) {
            placeKleep();
            kleepObserver.disconnect();
          }
        });
        kleepObserver.observe(document.body, { childList: true, subtree: true });
        // On arrête d'observer au bout d'un délai large (produit sans reco Kleep).
        setTimeout(function () {
          kleepObserver.disconnect();
        }, 20000);
      }

      var resizeTimer;
      $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(placeKleep, 200);
      });
    }
  })();

  // Le calcul initial de --hero-h (visuel hero mobile) est fait en synchrone
  // dans main-product.liquid, avant le 1er rendu (voir sizeMobileHero exposée
  // sur window). On ne recalcule ici QUE sur un vrai changement de LARGEUR
  // (ou rotation) — pas sur les variations de hauteur dues à la barre d'URL
  // iOS qui se rétracte au scroll. À ce moment seulement, on re-fige la
  // hauteur de référence.
  var heroResizeTimer;
  var lastHeroWidth = window.innerWidth;
  $(window).on("resize orientationchange", function (e) {
    if (e.type === "resize" && window.innerWidth === lastHeroWidth) {
      return;
    }
    lastHeroWidth = window.innerWidth;
    window.heroVH = window.innerHeight;
    clearTimeout(heroResizeTimer);
    heroResizeTimer = setTimeout(function () {
      if (window.sizeMobileHero) {
        window.sizeMobileHero();
      }
    }, 200);
  });

  // Tiroir Panier
  // ----------------------------------------------------------------------------
  swiper_reassurance();

    // Sections administrables
  // --------------------------------------------
  if ($(".section-accordeon").length) {
    $(".tabs h3").on("click", function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).next("div").hide();
      } else {
        $(".tabs h3").removeClass("active");
        $(".tabs h3").next("div").hide();
        $(this).addClass("active");
        $(this).next("div").show();
      }
    });
  }
});

function swiper_reassurance() {
  // Réassurance uniquement — les cartes produit utilisent aussi .mySwiper,
  // mais leur swiper est géré par <card-product> (ne pas le percuter ici).
  if ($(".drawer__reassurance").length) {
    new Swiper(".drawer__reassurance", {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  }
}

$.fn.isInViewport = function () {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

function isInViewport(el) {
  if (typeof el.get(0) === "undefined") {
    return false;
  }

  const rect = el.get(0).getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= ($(window).height() || $(document).height()) && rect.right <= ($(window).width() || $(document).width());
}
// Barre sticky d'ajout au panier : toujours visible sur mobile (les éléments
// équivalents de product-info sont masqués en CSS), gérée uniquement par le CSS.

/*** Custom element Carte produit : pilote son propre JS (swiper d'images) */
function initCardProductSwiper(scope) {
  var cards;
  if (scope && scope.matches && scope.matches("card-product")) {
    cards = [scope];
  } else {
    cards = (scope || document).querySelectorAll("card-product");
  }
  cards.forEach(function (card) {
    // Le swiper de la carte (peu importe sa classe : mySwiper, etc.)
    var el = card.querySelector(".card__media .swiper");
    if (!el) {
      return;
    }
    // Dans les sliders de recommandations (.cross_content : vous aimerez aussi /
    // shop the look / vus récemment) et dans l'upsell du panier (.drawer__upsell),
    // le swiper interne des cartes doit rester DÉSACTIVÉ : son JS capte le geste
    // horizontal (preventDefault sur touchmove) et bloque le scroll du
    // slider-component parent quand on pose le doigt sur un visuel. On le
    // neutralise même s'il a déjà été initialisé — cas des cartes "vous aimerez
    // aussi" injectées en AJAX par <product-recommendations>, pour lesquelles ce
    // test doit passer AVANT le court-circuit swiper-initialized.
    // (single-slide masque flèches/scrollbar, .swiper clippe la 2e image.)
    if (card.closest(".cross_content") || card.closest(".drawer__upsell")) {
      if (el.swiper) {
        el.swiper.destroy(true, true);
      }
      el.classList.add("single-slide");
      // Le swiper étant désactivé, on rétablit touch-action pour que le geste
      // horizontal sur le visuel atteigne le slider parent (scroll). En inline
      // car la règle de base .card__media .swiper{touch-action:pan-y} le bloque.
      el.style.touchAction = "auto";
      return;
    }
    if (el.swiper || el.__swiperArmed) {
      return;
    }
    var slides = el.querySelectorAll(".swiper-slide");
    if (slides.length <= 1) {
      // Une seule image : pas de swiper ni de scrollbar/flèches
      el.classList.add("single-slide");
      return;
    }
    armCardProductSwiper(card, el);
  });
}

var lastScroll = 0;
window.addEventListener("scroll", function () { lastScroll = performance.now(); }, { passive: true });

function armCardProductSwiper(card, el) {
  // Propriété, pas classe : une classe partirait dans le cache de l'infinite scroll.
  el.__swiperArmed = true;
  // capture : sinon le 1er swipe est perdu.
  var opts = { capture: true, passive: true };
  var onHover = function () {
    if (performance.now() - lastScroll > 300) arm();
    else card.addEventListener("pointermove", onHover);
  };
  var onArrowClick = function (e) {
    var arrow = e.target.closest(".swiper-button-next, .swiper-button-prev");
    if (!arrow) return;
    e.preventDefault();
    e.stopPropagation();
    arm();
    if (!el.swiper) return;
    if (arrow.classList.contains("swiper-button-next")) el.swiper.slideNext();
    else el.swiper.slidePrev();
  };
  var arm = function () {
    card.removeEventListener("pointerenter", onHover);
    card.removeEventListener("pointermove", onHover);
    card.removeEventListener("pointerdown", arm, opts);
    card.removeEventListener("click", onArrowClick, true);
    createCardProductSwiper(el);
  };
  card.addEventListener("pointerenter", onHover);
  card.addEventListener("pointerdown", arm, opts);
  card.addEventListener("click", onArrowClick, true);
}

function createCardProductSwiper(el) {
  if (typeof Swiper === "undefined" || el.swiper) {
    return;
  }
  new Swiper(el, {
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: el.querySelector(".swiper-button-next"),
      prevEl: el.querySelector(".swiper-button-prev"),
    },
    scrollbar: {
      el: el.querySelector(".swiper-scrollbar"),
      hide: false,
      draggable: true,
    },
    breakpoints: {
      0: { allowTouchMove: true },
      789: { allowTouchMove: true },
    },
  });

  // Les flèches et la scrollbar sont dans le lien <a class="card__media"> :
  // on empêche la navigation vers la fiche produit quand on les manipule.
  el.querySelectorAll(".swiper-button-next, .swiper-button-prev, .swiper-scrollbar").forEach(function (ctrl) {
    ctrl.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
    });
    ctrl.addEventListener("mousedown", function (e) {
      e.stopPropagation();
    });
  });
}

// Init au chargement (cartes présentes dans le HTML initial)
$(document).ready(function () {
  initCardProductSwiper(document);

  // Filet de sécurité : les cartes "vous aimerez aussi" sont injectées en AJAX
  // par <product-recommendations> APRÈS le ready. On retraite leurs cartes dès
  // que le contenu est inséré pour désactiver leur swiper interne (sinon il
  // bloque le scroll horizontal du slider). Idempotent avec connectedCallback.
  document.querySelectorAll("product-recommendations").forEach(function (pr) {
    new MutationObserver(function () {
      initCardProductSwiper(pr);
    }).observe(pr, { childList: true });
  });

  // Sécurité : un clic sur le quick-add ne doit jamais déclencher la
  // redirection carte (handler .card__inner délégué sur document).
  $(document).on("click", "card-product .quick-add", function (e) {
    e.stopPropagation();
  });

  // Description de collection : bouton « Voir plus / Voir moins » (clamp 4 lignes)
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initCollectionHeroClamp);
  } else {
    initCollectionHeroClamp();
  }
});

function initCollectionHeroClamp() {
  document.querySelectorAll(".collection-hero__description").forEach(function (desc) {
    if (desc.dataset.clampInit) {
      return;
    }
    desc.dataset.clampInit = "1";
    // La description est déjà tronquée à 4 lignes par le CSS.
    // On n'ajoute le bouton que si le contenu déborde réellement.
    if (desc.scrollHeight <= desc.clientHeight + 1) {
      return;
    }
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "collection-hero__description-toggle";
    btn.textContent = "Voir plus";
    btn.addEventListener("click", function () {
      var expanded = desc.classList.toggle("is-expanded");
      btn.textContent = expanded ? "Voir moins" : "Voir plus";
    });
    desc.insertAdjacentElement("afterend", btn);
  });
}

class CardProduct extends HTMLElement {
  connectedCallback() {
    // Init pour les cartes ajoutées dynamiquement (load-more, facettes, quick-add…)
    initCardProductSwiper(this);
  }
}

if (!customElements.get("card-product")) {
  customElements.define("card-product", CardProduct);
}

var lazyVideoObserver = "IntersectionObserver" in window ? new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) entry.target.play().catch(function () {});
    else entry.target.pause();
  });
}) : null;

class LazyVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector("video");
    if (lazyVideoObserver && this.video) lazyVideoObserver.observe(this.video);
  }

  disconnectedCallback() {
    if (lazyVideoObserver && this.video) lazyVideoObserver.unobserve(this.video);
  }
}

if (!customElements.get("lazy-video")) {
  customElements.define("lazy-video", LazyVideo);
}

